import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../../context/auth";
import Loading from "../../../components/Loading/Loading";
import analiseInfracao_api from "../../../api/analiseInfracao_api";
import FichaInfracao from "../FichaInfracao";
import { showMessage } from "../../../helpers/message";

export default function FichaInfracaoHistorico() {
  const { state } = useLocation();
  const resetId = state?.resetId;
  const { loading, setLoading } = useAuth();
  const [dto, setDto] = useState(null);

  useEffect(() => {
    const fetchBackup = async () => {
      if (!resetId) return;
      try {
        setLoading(true);
        const response = await analiseInfracao_api.GetResetFicha(resetId);
        setDto(response?.data ?? null);
      } catch (error) {
        showMessage("Erro", error?.message ?? "Falha ao carregar ficha histórica", "error", null);
      } finally {
        setLoading(false);
      }
    };
    fetchBackup();
  }, [resetId]);

  if (loading || !dto) return <Loading />;

  // Reutiliza o componente da ficha, passando o DTO e ativando modo histórico (somente leitura)
  return <FichaInfracao fichaExterna={dto} historico={true} />;
}
